export default [
  "emailupdates",
  "email",
  "name-first",
  "name-middle",
  "name-last",
  "name-suffix",
  "phone-number",
  "address",
  "address-zip",
  "address-state",
  "address-street",
  "address-street-2",
  "address-city",
  "address-county",
  "address-unit-type",
  "address-unit-number",
  "address-municipality",
  "mailing-address-is-outside-usa",
  "mailing-address-country",
  "mailing-address-street",
  "mailing-address-street-2",
  "mailing-address-unit-type",
  "mailing-address-unit-number",
  "mailing-address-city",
  "mailing-address-state",
  "mailing-address-state-ex-us",
  "mailing-address-zip",
  "mailing-address-postcode",
  "mailing-address-is-my",
  "political-party",
  "gender",
  "race",
  "date-of-birth",
  "lived-at-since",
  "same-mailing-address",
  "previous-first-name",
  "previous-last-name",
  "previous-address",
  "previous-city",
  "previous-state",
  "previous-zip",
  "previous-county",
  "new-registration",
  "change-name",
  "change-address",
  "change-party",
  "fed-state-employee",
  "voter-registration-number",
  "annual-mailin-request",
  "annual-ballot-request",
  "penndot-number",
  "source",
];
